module.exports = __webpack_public_path__ + "static/media/IMG_1148.1f05df1d.JPG";